import React from 'react';
import { useUpdateAvatars } from '../../../../../services/update-avatars/index.tsx';
import { NavigationKitAvatarPopup } from './navigation-kit-avatar-popup/NavigationKitAvatarPopup.tsx';

type NavigationKitAvatarProps = {
	projectId: number;
	selectedAvatarUrl: string;
	canEdit: boolean;
};
// TODO: JGFENG-1029 - Clean up redundant component
export const NavigationKitAvatar = ({
	projectId,
	selectedAvatarUrl,
	canEdit,
}: NavigationKitAvatarProps) => {
	const { systemAvatars, latestCustomAvatar, updateProjectAvatar, uploadProjectAvatar } =
		useUpdateAvatars(projectId, selectedAvatarUrl);

	return (
		<NavigationKitAvatarPopup
			selectedAvatarUrl={selectedAvatarUrl}
			systemAvatars={systemAvatars}
			latestCustomAvatar={latestCustomAvatar}
			onSelectAvatar={updateProjectAvatar}
			onUploadAvatar={uploadProjectAvatar}
			canEdit={canEdit}
			projectId={projectId}
		/>
	);
};
